import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=cb44285e&scoped=true"
import script from "./connect.vue?vue&type=script&lang=js"
export * from "./connect.vue?vue&type=script&lang=js"
import style0 from "./connect.vue?vue&type=style&index=0&id=cb44285e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb44285e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb44285e')) {
      api.createRecord('cb44285e', component.options)
    } else {
      api.reload('cb44285e', component.options)
    }
    module.hot.accept("./connect.vue?vue&type=template&id=cb44285e&scoped=true", function () {
      api.rerender('cb44285e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel/connect.vue"
export default component.exports